// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropbox[data-v-576b9628]{background:#e0ffff;color:dimgray;min-height:150px;outline:2px dashed grey;outline-offset:-10px;padding:10px;position:relative}.dropbox[data-v-576b9628],.input-file[data-v-576b9628]{cursor:pointer;height:150px}.input-file[data-v-576b9628]{opacity:0;position:absolute;width:100%}.dropbox[data-v-576b9628]:hover{background:#add8e6}.dropbox p[data-v-576b9628]{font-size:1.2em;padding:25px 0;text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
